import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  IconButton,
  Chip,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Card,
  CardContent,
  Avatar,
  Container,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { getNonSubscribedUsers } from "../../../../Services/ReportsApi";
import { activateAccountManually } from "../../../../Services/ClintsApi";
import CreateClientVersionDialog from "./CreateClientVersionDialog";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import EventIcon from "@mui/icons-material/Event";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CodeIcon from "@mui/icons-material/Code";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DateRangeIcon from "@mui/icons-material/DateRange";
import FilterListIcon from "@mui/icons-material/FilterList";
import BusinessIcon from "@mui/icons-material/Business";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const NonSubscriberSustomersTap = ({
  onActivateAccount,
  activatingUsers = [],
}) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState({
    startDate: "",
    endDate: ""
  });
  const [brokerCodeFilter, setBrokerCodeFilter] = useState("");
  const [accountStatusFilter, setAccountStatusFilter] = useState("");

  useEffect(() => {
    getNonSubscribedUsers()
      .then((res) => {
        setCustomers(res.data || []);
      })
      .catch(() => setCustomers([]))
      .finally(() => setLoading(false));
  }, []);

  const getStatusColor = (status) => {
    return status === 1 ? "success" : "error";
  };

  const getStatusText = (status) => {
    return status === 1 ? "نشط" : "غير نشط";
  };

  const getEmailVerificationStatus = (emailVerified) => {
    return emailVerified ? "مفعل" : "غير مفعل";
  };

  const getEmailVerificationColor = (emailVerified) => {
    return emailVerified ? "success" : "warning";
  };

  // دالة لاختصار البريد الإلكتروني
  const getShortEmail = (email) => {
    if (!email) return "";
    const atIndex = email.indexOf("@");
    return atIndex > 0 ? email.substring(0, atIndex) : email;
  };

  const handleActivateAccount = async (customerId, customerName) => {
    try {
      const confirmActivation = window.confirm(
        `هل أنت متأكد أنك تريد تفعيل حساب العميل "${customerName}"؟`
      );
      if (!confirmActivation) return;

      // إظهار تحميل
      onActivateAccount && onActivateAccount(customerId);

      const res = await activateAccountManually(customerId);

      if (
        res?.data?.status === true ||
        res?.data?.message?.includes("success")
      ) {
        alert("✅ تم تفعيل الحساب بنجاح!");
        // تحديث القائمة بعد التفعيل
        setCustomers((prev) =>
          prev.map((c) => (c.id === customerId ? { ...c, active: 1 } : c))
        );
      } else {
        alert("⚠️ لم يتم تفعيل الحساب، تحقق من السيرفر");
      }
    } catch (error) {
      console.error("❌ فشل تفعيل الحساب:", error);
      alert("❌ حدث خطأ أثناء تفعيل الحساب");
    }
  };
  const handleOpenDialog = (customer) => {
    setSelectedCustomer(customer);
    setOpenDialog(true);
  };

  // ✅ إغلاق الديالوج
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  // ✅ حفظ النسخة الجديدة

  // دالة البحث والفلترة
  const filteredCustomers = customers.filter((customer) => {
    const query = searchQuery.toLowerCase();
    const matchesSearch = 
      customer.name?.toLowerCase().includes(query) ||
      customer.email?.toLowerCase().includes(query) ||
      customer.phone?.toLowerCase().includes(query) ||
      customer.code?.toLowerCase().includes(query);

    // فلترة التاريخ
    let matchesDate = true;
    if (dateFilter.startDate || dateFilter.endDate) {
      const customerDate = new Date(customer.created_at);
      customerDate.setHours(0, 0, 0, 0);

      if (dateFilter.startDate) {
        const startDate = new Date(dateFilter.startDate);
        startDate.setHours(0, 0, 0, 0);
        matchesDate = matchesDate && customerDate >= startDate;
      }

      if (dateFilter.endDate) {
        const endDate = new Date(dateFilter.endDate);
        endDate.setHours(23, 59, 59, 999);
        matchesDate = matchesDate && customerDate <= endDate;
      }
    }

    // فلترة كود الموزع
    const matchesBrokerCode = brokerCodeFilter === "" || 
      (brokerCodeFilter === "none" && !customer.user_broker_code) ||
      (brokerCodeFilter === "has" && customer.user_broker_code);

    // فلترة حالة الحساب
    const matchesAccountStatus = accountStatusFilter === "" || 
      (accountStatusFilter === "1" && customer.active === 1) || 
      (accountStatusFilter === "0" && customer.active === 0);

    return matchesSearch && matchesDate && matchesBrokerCode && matchesAccountStatus;
  });

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  const handleClearDateFilter = () => {
    setDateFilter({
      startDate: "",
      endDate: ""
    });
  };

  const handleClearAllFilters = () => {
    setSearchQuery("");
    setDateFilter({
      startDate: "",
      endDate: ""
    });
    setBrokerCodeFilter("");
    setAccountStatusFilter("");
  };

  const isFiltered = searchQuery || dateFilter.startDate || dateFilter.endDate || brokerCodeFilter || accountStatusFilter;

  // استخراج أكواد الموزعين الفريدة
  const uniqueBrokerCodes = [...new Set(customers.map(c => c.user_broker_code).filter(Boolean))];

  // دالة لتصدير البيانات إلى CSV (يفتح في Excel)
  const exportToExcel = () => {
    try {
      // استخدم filteredCustomers (المصفّاة) كمصدر للبيانات
      const rows = filteredCustomers.map((c) => ({
        name: c.name ?? "",
        email: c.email ?? "",
        phone: c.phone ?? "",
        code: c.code ?? "",
        broker: c.user_broker_code ?? "",
        account_status: c.active === 1 ? "نشط" : "غير نشط",
        email_status: c.status ? "مفعل" : "غير مفعل",
        created_at: c.created_at ? new Date(c.created_at).toLocaleDateString("ar-EG") : "",
      }));

      // رؤوس الأعمدة بالعربية
      const headers = [
        "الاسم",
        "البريد الإلكتروني",
        "رقم الهاتف",
        "كود العميل",
        "كود الموزع",
        "حالة الحساب",
        "حالة البريد",
        "تاريخ التسجيل",
      ];

      // تحويل إلى CSV مع اقتباس القيم والتأكد من عدم كسر الفواصل
      const escapeValue = (val) =>
        `"${String(val).replace(/"/g, '""')}"`;

      const csvLines = [
        headers.map(escapeValue).join(","), // header
        ...rows.map((r) =>
          [
            r.name,
            r.email,
            r.phone,
            r.code,
            r.broker,
            r.account_status,
            r.email_status,
            r.created_at,
          ]
            .map(escapeValue)
            .join(",")
        ),
      ];

      // إضافة BOM لضمان فتح UTF-8 في Excel
      const csvContent = "\uFEFF" + csvLines.join("\r\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "non_subscribers_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed", err);
      alert("فشل تصدير الملف");
    }
  };

  return (
    <Container maxWidth="xl">
      {/* Header */}
      <Card
        elevation={3}
        sx={{
          mb: 3,
          background:
            "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar
                sx={{
                  bgcolor: "white",
                  color: "#f5576c",
                  width: 50,
                  height: 50,
                }}
              >
                <PersonOffIcon sx={{ fontSize: 32 }} />
              </Avatar>
              <Box>
                <Typography
                  variant="h4"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  العملاء بدون باقة
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: "rgba(255,255,255,0.9)" }}
                >
                  إدارة العملاء الذين لم يشتركوا بعد
                </Typography>
              </Box>
            </Box>

            {/* UPDATED: عرض العداد وزر التصدير */}
            {!loading && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Chip
                  label={`${customers.length} عميل`}
                  sx={{
                    bgcolor: "white",
                    color: "#f5576c",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    px: 2,
                    py: 3,
                  }}
                />
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  startIcon={<FileDownloadIcon />}
                  onClick={exportToExcel}
                  sx={{ ml: 1, bgcolor: "white", color: "#1976d2", fontWeight: "bold" }}
                >
                  تصدير للإكسل
                </Button>
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 8,
          }}
        >
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ ml: 2 }}>
            جاري تحميل البيانات...
          </Typography>
        </Box>
      ) : customers.length > 0 ? (
        <>
          {/* شريط البحث */}
          <Card 
            variant="outlined" 
            sx={{ 
              mb: 2, 
              bgcolor: '#f8f9fa',
              border: '2px solid #e3f2fd'
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: '#1976d2' }}>
                  <SearchIcon />
                </Avatar>
                <TextField
                  fullWidth
                  placeholder="ابحث في العملاء (الاسم، البريد، الهاتف، الكود...)"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  variant="outlined"
                  sx={{ 
                    bgcolor: 'white',
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: '#1976d2',
                      },
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="primary" />
                      </InputAdornment>
                    ),
                    endAdornment: searchQuery && (
                      <InputAdornment position="end">
                        <Tooltip title="مسح البحث">
                          <IconButton
                            onClick={handleClearSearch}
                            edge="end"
                            size="small"
                            sx={{ 
                              bgcolor: '#ffebee',
                              '&:hover': {
                                bgcolor: '#ffcdd2'
                              }
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </CardContent>
          </Card>

          {/* فلتر التاريخ */}
          <Card 
            variant="outlined" 
            sx={{ 
              mb: 3, 
              bgcolor: '#fff3e0',
              border: '2px solid #ffe0b2'
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Avatar sx={{ bgcolor: '#ff9800' }}>
                  <FilterListIcon />
                </Avatar>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#ff9800' }}>
                  فلترة حسب تاريخ التسجيل:
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, flexWrap: 'wrap' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 200 }}>
                    <DateRangeIcon sx={{ color: '#ff9800' }} />
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#ff9800' }}>
                      من:
                    </Typography>
                    <TextField
                      type="date"
                      size="small"
                      value={dateFilter.startDate}
                      onChange={(e) => setDateFilter(prev => ({ ...prev, startDate: e.target.value }))}
                      sx={{ 
                        bgcolor: 'white',
                        minWidth: 150
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 200 }}>
                    <DateRangeIcon sx={{ color: '#ff9800' }} />
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#ff9800' }}>
                      إلى:
                    </Typography>
                    <TextField
                      type="date"
                      size="small"
                      value={dateFilter.endDate}
                      onChange={(e) => setDateFilter(prev => ({ ...prev, endDate: e.target.value }))}
                      sx={{ 
                        bgcolor: 'white',
                        minWidth: 150
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  {(dateFilter.startDate || dateFilter.endDate) && (
                    <Tooltip title="مسح فلتر التاريخ">
                      <IconButton
                        onClick={handleClearDateFilter}
                        size="small"
                        sx={{ 
                          bgcolor: '#ffebee',
                          '&:hover': {
                            bgcolor: '#ffcdd2'
                          }
                        }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
                {isFiltered && (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Chip 
                      label={`${filteredCustomers.length} نتيجة`}
                      color="warning"
                      sx={{ fontWeight: 'bold' }}
                    />
                    <Tooltip title="مسح جميع الفلاتر">
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        startIcon={<ClearIcon />}
                        onClick={handleClearAllFilters}
                        sx={{ fontWeight: 'bold' }}
                      >
                        مسح الكل
                      </Button>
                    </Tooltip>
                  </Box>
                )}
              </Box>
              {isFiltered && (
                <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
                  {searchQuery && (
                    <Chip 
                      label={`البحث: "${searchQuery}"`}
                      color="warning"
                      onDelete={handleClearSearch}
                      sx={{ fontWeight: 'bold' }}
                    />
                  )}
                  {dateFilter.startDate && (
                    <Chip 
                      label={`من: ${new Date(dateFilter.startDate).toLocaleDateString('ar')}`}
                      color="warning"
                      onDelete={() => setDateFilter(prev => ({ ...prev, startDate: "" }))}
                      sx={{ fontWeight: 'bold' }}
                    />
                  )}
                  {dateFilter.endDate && (
                    <Chip 
                      label={`إلى: ${new Date(dateFilter.endDate).toLocaleDateString('ar')}`}
                      color="warning"
                      onDelete={() => setDateFilter(prev => ({ ...prev, endDate: "" }))}
                      sx={{ fontWeight: 'bold' }}
                    />
                  )}
                </Box>
              )}
            </CardContent>
          </Card>

          {/* فلاتر كود الموزع وحالة الحساب */}
          <Card 
            variant="outlined" 
            sx={{ 
              mb: 3, 
              bgcolor: '#f3e5f5',
              border: '2px solid #e1bee7'
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Avatar sx={{ bgcolor: '#9c27b0' }}>
                  <FilterListIcon />
                </Avatar>
                
                {/* فلتر كود الموزع */}
                <Box sx={{ minWidth: 250 }}>
                  <FormControl fullWidth size="small" sx={{ bgcolor: 'white' }}>
                    <InputLabel>فلترة حسب كود الموزع</InputLabel>
                    <Select
                      value={brokerCodeFilter}
                      label="فلترة حسب كود الموزع"
                      onChange={(e) => setBrokerCodeFilter(e.target.value)}
                    >
                      <MenuItem value="">
                        <em>جميع العملاء</em>
                      </MenuItem>
                      <MenuItem value="has">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <BusinessIcon fontSize="small" color="secondary" />
                          <span>لديهم كود موزع</span>
                          <Chip 
                            label={customers.filter(c => c.user_broker_code).length} 
                            size="small" 
                            color="secondary"
                          />
                        </Box>
                      </MenuItem>
                      <MenuItem value="none">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <ErrorOutlineIcon fontSize="small" color="error" />
                          <span>بدون كود موزع</span>
                          <Chip 
                            label={customers.filter(c => !c.user_broker_code).length} 
                            size="small" 
                            color="default"
                          />
                        </Box>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                {/* فلتر حالة الحساب */}
                <Box sx={{ minWidth: 250 }}>
                  <FormControl fullWidth size="small" sx={{ bgcolor: 'white' }}>
                    <InputLabel>فلترة حسب حالة الحساب</InputLabel>
                    <Select
                      value={accountStatusFilter}
                      label="فلترة حسب حالة الحساب"
                      onChange={(e) => setAccountStatusFilter(e.target.value)}
                    >
                      <MenuItem value="">
                        <em>جميع الحالات</em>
                      </MenuItem>
                      <MenuItem value="1">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircleIcon fontSize="small" color="success" />
                          <span>حسابات نشطة</span>
                          <Chip 
                            label={customers.filter(c => c.active === 1).length} 
                            size="small" 
                            color="success"
                          />
                        </Box>
                      </MenuItem>
                      <MenuItem value="0">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <ErrorOutlineIcon fontSize="small" color="error" />
                          <span>حسابات غير نشطة</span>
                          <Chip 
                            label={customers.filter(c => c.active === 0).length} 
                            size="small" 
                            color="error"
                          />
                        </Box>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                {/* زر مسح الفلاتر */}
                {(brokerCodeFilter || accountStatusFilter) && (
                  <Tooltip title="مسح فلاتر كود الموزع والحالة">
                    <IconButton
                      onClick={() => {
                        setBrokerCodeFilter("");
                        setAccountStatusFilter("");
                      }}
                      size="small"
                      sx={{ 
                        bgcolor: '#ffebee',
                        '&:hover': {
                          bgcolor: '#ffcdd2'
                        }
                      }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}

                {/* عرض النتائج */}
                {isFiltered && (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', ml: 'auto' }}>
                    <Chip 
                      label={`${filteredCustomers.length} نتيجة`}
                      color="secondary"
                      sx={{ fontWeight: 'bold' }}
                    />
                    <Tooltip title="مسح جميع الفلاتر">
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        startIcon={<ClearIcon />}
                        onClick={handleClearAllFilters}
                        sx={{ fontWeight: 'bold' }}
                      >
                        مسح الكل
                      </Button>
                    </Tooltip>
                  </Box>
                )}
              </Box>

              {/* عرض الفلاتر النشطة */}
              {(brokerCodeFilter || accountStatusFilter) && (
                <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
                  {brokerCodeFilter && (
                    <Chip 
                      label={brokerCodeFilter === "has" ? "لديهم كود موزع" : "بدون كود موزع"}
                      color="secondary"
                      onDelete={() => setBrokerCodeFilter("")}
                      sx={{ fontWeight: 'bold' }}
                    />
                  )}
                  {accountStatusFilter && (
                    <Chip 
                      label={accountStatusFilter === "1" ? "حسابات نشطة" : "حسابات غير نشطة"}
                      color="secondary"
                      onDelete={() => setAccountStatusFilter("")}
                      sx={{ fontWeight: 'bold' }}
                    />
                  )}
                </Box>
              )}
            </CardContent>
          </Card>

          {filteredCustomers.length > 0 ? (
            <Card elevation={3} sx={{ borderRadius: 2 }}>
              <TableContainer component={Paper} elevation={0}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        الاسم
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        البريد الإلكتروني
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        رقم الهاتف
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        كود العميل
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        كود الموزع
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        حالة الحساب
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        حالة البريد
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        تاريخ التسجيل
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", fontSize: "1rem" }}
                      >
                        إجراءات
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredCustomers.map((customer) => (
                      <TableRow
                        key={customer.id}
                        sx={{
                          "&:hover": {
                            bgcolor: customer.active === 1 ? "#e8f5e9" : "#fff3e0",
                            transition: "all 0.2s",
                          },
                          bgcolor: customer.active === 1 ? "transparent" : "#fffde7",
                        }}
                      >
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Avatar
                              sx={{
                                bgcolor:
                                  customer.active === 1
                                    ? "#4caf50"
                                    : "#ff9800",
                                width: 32,
                                height: 32,
                              }}
                            >
                              <PersonIcon fontSize="small" />
                            </Avatar>
                            <Typography sx={{ fontWeight: "bold" }}>
                              {customer.name}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Tooltip title={customer.email} arrow>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <EmailIcon sx={{ color: "#666", fontSize: 18 }} />
                              <Typography variant="body2">
                                {getShortEmail(customer.email)}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <PhoneIcon sx={{ color: "#666", fontSize: 18 }} />
                            <Chip
                              label={customer.phone}
                              size="small"
                              variant="outlined"
                            />
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <CodeIcon sx={{ color: "#666", fontSize: 18 }} />
                            <Chip
                              label={customer.code}
                              size="small"
                              color="info"
                              sx={{ fontFamily: "monospace" }}
                            />
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <BusinessIcon sx={{ color: "#666", fontSize: 18 }} />
                            {customer.user_broker_code ? (
                              <Chip
                                label={customer.user_broker_code}
                                size="small"
                                color="secondary"
                                variant="outlined"
                                sx={{ fontFamily: "monospace" }}
                              />
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                لا يوجد
                              </Typography>
                            )}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip
                            icon={
                              customer.active === 1 ? (
                                <CheckCircleIcon />
                              ) : (
                                <ErrorOutlineIcon />
                              )
                            }
                            label={getStatusText(customer.active)}
                            color={getStatusColor(customer.active)}
                            size="small"
                            sx={{ fontWeight: "bold" }}
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            icon={customer.status ? <CheckCircleIcon /> : <ErrorOutlineIcon />}
                            label={getEmailVerificationStatus(customer.status)}
                            color={getEmailVerificationColor(customer.status)}
                            variant="outlined"
                            size="small"
                            sx={{ fontWeight: "bold" }}
                          />
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <EventIcon sx={{ color: "#666", fontSize: 18 }} />
                            <Typography variant="body2">
                              {new Date(customer.created_at).toLocaleDateString("ar-EG")}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 0.5,
                              flexWrap: "wrap",
                            }}
                          >
                            <Tooltip title="عرض التفاصيل">
                              <IconButton
                                color="info"
                                size="small"
                                sx={{
                                  bgcolor: "#e3f2fd",
                                  "&:hover": { bgcolor: "#bbdefb" },
                                }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            {customer.active !== 1 && (
                              <Tooltip title="تفعيل الحساب">
                                <IconButton
                                  color="success"
                                  size="small"
                                  onClick={() =>
                                    handleActivateAccount(customer.id, customer.name)
                                  }
                                  disabled={activatingUsers.includes(customer.id)}
                                  sx={{
                                    bgcolor: "#e8f5e9",
                                    "&:hover": { bgcolor: "#c8e6c9" },
                                    "&:disabled": { bgcolor: "#f5f5f5" },
                                  }}
                                >
                                  {activatingUsers.includes(customer.id) ? (
                                    <CircularProgress size={18} />
                                  ) : (
                                    <PowerSettingsNewIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </Tooltip>
                            )}

                            {customer.active === 1 && (
                              <Tooltip title="إنشاء نسخة للعميل">
                                <IconButton
                                  color="secondary"
                                  size="small"
                                  onClick={() => handleOpenDialog(customer)}
                                  sx={{
                                    bgcolor: "#f3e5f5",
                                    "&:hover": { bgcolor: "#e1bee7" },
                                  }}
                                >
                                  <FileCopyIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ) : (
            <Box sx={{ textAlign: 'center', py: 8, bgcolor: '#fff3e0', borderRadius: 2, border: '2px dashed #ff9800' }}>
              <SearchIcon sx={{ fontSize: 80, color: '#ff9800', mb: 2 }} />
              <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                لا توجد نتائج للبحث
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                جرب تغيير معايير البحث أو الفلترة
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                {searchQuery && (
                  <Chip 
                    label={`البحث: "${searchQuery}"`}
                    color="warning"
                    onDelete={handleClearSearch}
                    sx={{ fontWeight: 'bold' }}
                  />
                )}
                {dateFilter.startDate && (
                  <Chip 
                    label={`من: ${new Date(dateFilter.startDate).toLocaleDateString('ar')}`}
                    color="warning"
                    sx={{ fontWeight: 'bold' }}
                  />
                )}
                {dateFilter.endDate && (
                  <Chip 
                    label={`إلى: ${new Date(dateFilter.endDate).toLocaleDateString('ar')}`}
                    color="warning"
                    sx={{ fontWeight: 'bold' }}
                  />
                )}
                {brokerCodeFilter && (
                  <Chip 
                    label={brokerCodeFilter === "has" ? "لديهم كود موزع" : "بدون كود موزع"}
                    color="warning"
                    onDelete={() => setBrokerCodeFilter("")}
                    sx={{ fontWeight: 'bold' }}
                  />
                )}
                {accountStatusFilter && (
                  <Chip 
                    label={accountStatusFilter === "1" ? "حسابات نشطة" : "حسابات غير نشطة"}
                    color="warning"
                    onDelete={() => setAccountStatusFilter("")}
                    sx={{ fontWeight: 'bold' }}
                  />
                )}
              </Box>
              <Button
                variant="contained"
                color="warning"
                startIcon={<ClearIcon />}
                onClick={handleClearAllFilters}
                sx={{ mt: 2, fontWeight: 'bold' }}
              >
                مسح جميع الفلاتر
              </Button>
            </Box>
          )}
        </>
      ) : (
        <Box
          sx={{
            textAlign: "center",
            py: 8,
            bgcolor: "#f5f5f5",
            borderRadius: 2,
          }}
        >
          <PersonOffIcon sx={{ fontSize: 80, color: "#bdbdbd", mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            لا توجد عملاء غير مشتركين
          </Typography>
        </Box>

      )}

      <CreateClientVersionDialog
        open={openDialog}
        onClose={(success) => {
          setOpenDialog(false);
          setSelectedCustomer(null);
          if (success) {
            getNonSubscribedUsers()
              .then((res) => {
                setCustomers(res.data || []);
              })
              .catch(() => setCustomers([]));
          }
        }}
        customer={selectedCustomer}
      />
    </Container>
  );
};

export default NonSubscriberSustomersTap;
